module.exports = __webpack_public_path__ + "img/MailIcon.a3c5b222.svg";